<template>
  <b-form @submit.prevent="submitForm" ref="form" :validated="validated" novalidate>
    <fieldset>
      <SignupLegend title="Please enter your email address"/>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Email</label>
        <div class="col-sm-9">
          <input type="email" class="form-control" placeholder="email" required v-model="email">
          <div class="invalid-feedback">Valid email address is required.</div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12">
          <button type="submit" class="btn btn-primary float-right">
            <span class="fas fa-envelope"></span> Send password reset
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <a :href="`mailto:support@getaio.co.uk?Subject=${subject}&body=${body}`" class="float-right">I don't remember
            my account</a>
        </div>
      </div>
    </fieldset>
  </b-form>
</template>

<script>
  import EventBus from '@/utils/EventBus'
  import SignupLegend from '@/components/SignupLegend'
  import api from '@/utils/api'

  export default {
    components: {
      SignupLegend
    },
    data () {
      return {
        body: encodeURI(`Hi,

my name is: PLEASE_ENTER_YOUR_NAME
and I used to have an aio* account with my company: PLEASE_ENTER_YOUR_COMPANY_NAME
My current email address is: PLEASE_ENTER_YOUR_EMAIL_ADDRESS

I need help in order to get access to my account again.

Thanks!`),
        email: '',
        subject: 'I don\'t remember my account name',
        validated: false
      }
    },
    methods: {
      async submitForm () {
        EventBus.$emit('hide-notification')
        this.validated = true
        if (this.$refs.form.checkValidity()) {
          await api.postInitResetPassword(this.email)
          this.email = ''
          this.validated = false
          EventBus.$emit('show-notification', 'success', 'You will receive an email with a link to reset your password. If you don\'t receive an email within 15 mins, please try again or contact support.')
        }
      }
    },
    mounted () {
      this.$emit('set-title', 'Reset your password')
    }
  }
</script>

<style lang="scss" scoped>
  .alert {
    margin-top: 30px;
  }
</style>
